export { CorporativoOnboardingCardId } from "./CorporativoOnboardingCardId";
